import { fileNameAndSize } from './photo-files';

/** The file's name in bold, and its size beside it in the small mono face. */
export function PhotoFileLine({ file }: { file: File }) {
  const { name, size } = fileNameAndSize(file);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: 8,
        fontSize: 12,
        color: 'var(--nb-ink-2)',
        minWidth: 0,
      }}
    >
      <span
        style={{
          fontWeight: 700,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {name}
      </span>
      <span
        className="nb-mono"
        style={{ fontSize: 10.5, color: 'var(--nb-muted)', whiteSpace: 'nowrap' }}
      >
        {size}
      </span>
    </div>
  );
}
